import useAuth from "./useAuth";
import useWeekSetting from "./useCurrentWeekSetting";
import useDeveloper from "./useDeveloper";
import useDocumentMaster from "./useDocumentMaster";
import useFocusMember from "./useFocusMember";
import useLandmarkMaster from "./useLandmarkMaster";
import useMaster from "./useMaster";
//import useMasterQuestion from "./useMasterQuestion";
import useMember from "./useMember";
import usePages from "./usePages";
import useProfile from "./useProfile";
import useProjectSite from "./useProjectSite";
import useSettingCategory from "./useSettingCategory";
import useSettingMaster from "./useSettingMaster";
import useSubTags from "./useSubTags";
import useSystemRole from "./useSystemRole";
import useSystemUser from "./useSystemUser";
import useTeamMember from "./useTeamMember";
// import useUser from "./useUser";

const containers = {
  auth: useAuth,
  profile: useProfile,
  // user: useUser,
  pages: usePages,
  developer: useDeveloper,
  master: useMaster,
  focusMember: useFocusMember,
  projectSite: useProjectSite,
  //masterQuestion: useMasterQuestion,
  subTags: useSubTags,
  documentmaster: useDocumentMaster,
  settingMaster: useSettingMaster,
  settingCategory: useSettingCategory,
  landmarkMaster: useLandmarkMaster,
  member: useMember,
  systemRole: useSystemRole,
  systemUser: useSystemUser,
  teammember: useTeamMember,
  weekSetting: useWeekSetting,
};

export default containers;
